import { Component, OnInit } from '@angular/core';
import {ValidateService} from '../../services/validate.service';
import {AuthService} from '../../services/auth.service';
import {FlashMessagesService} from 'angular2-flash-messages';
import {Router} from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
 /* options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: false,
    headers: [],
    showTitle: true,
    title: 'asfasf',
    useBom: false,
    removeNewLines: true,
    keys: ['prenom','nom','email','centre' ]
  };*/
	prenom: String;
	nom: String;
  email : String; 
  centre : String;  
  data: any;
	users: any;
	errorMessage: String;
  constructor(private validateService : ValidateService, 
   private flashMessagesService : FlashMessagesService,
   private authService: AuthService,
   private router :Router) { 

  
  
   }

  ngOnInit() {

   

 this.authService.getAllUsers()
 .subscribe(
 resUsers => this.users= resUsers

 ); 

 

  }
  myCSV(event) {
    console.log(event+"yessssssss");
    let data = this.users.map(d => { return { nom: d.nom, prenom: d.prenom,email:d.email,centre:d.centre }; })
   this.authService.downloadFile(data);
  }


}






// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts